module.exports = __webpack_public_path__ + "static/media/sv.1176ea28.svg";